import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { DocumentationContext } from '../../context/DocumentationContext'
import TextEditor from '../texteditor/TextEditor'
import DocCommentItem from './DocCommentItem'
import { Skeleton, Typography } from '@mui/material'
import { useContext } from 'react'

export default function DocComments() {
    const context = useContext(DocumentationContext)
    return (
        <div className='comments'>
            {context?.loadingComments ? <Skeleton
                title="skeleton"
                variant="rectangular"
                className='m-auto'
                width="90%"
                height="8rem"
                sx={{ margin: '1rem 0' }}
            /> : <>
                {context?.page?.comments.map(c => <DocCommentItem key={c.id} comment={c} />)}
                <div className={`comment-input ${context?.showCommentEditor && 'active'} ${context?.commentTarget && 'inactive'}`}>
                    {context?.showCommentEditor ? <TextEditor
                        onAccept={context.handleCommentSubmit}
                        onCancel={() => context.setShowCommentEditor(false)}
                        previousContent=''
                    /> : <>
                        <div className='comment-input-user'>
                            <FontAwesomeIcon icon='circle-user' style={{ fontSize: '1.5rem' }} />
                        </div>
                        <div className='comment-input-label w-100' onClick={() => context?.setShowCommentEditor(true)}>
                            <Typography variant='h5' color={'GrayText'} style={{ margin: '0', borderBottom: '1px solid gray' }}>
                                Escribe un comentario...
                            </Typography>
                        </div>
                    </>}
                </div>
            </>}
        </div>
    )
}
